interface AmplifyConfigOpts {
  Auth: {
    region: string;
    userPoolId: string;
    userPoolWebClientId: string;
    oauth: {
      domain: string;
      scope?: string[];
      redirectSignIn: string;
      redirectSignOut: string;
      responseType: 'code' | 'token';
    };
    cookieStorage?: {
      domain: string;
      path: string;
      expires: number;
      secure: boolean;
    };
  };
}

const AmplifyConfig: AmplifyConfigOpts = {
  Auth: {
    region: process.env.REACT_APP_AMPLIFY_AUTH_REGION!,
    userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_USER_POOL_ID!,
    userPoolWebClientId: process.env.REACT_APP_AMPLIFY_AUTH_USER_POOL_WEB_CLIENT_ID!,
    oauth: {
      domain: process.env.REACT_APP_AMPLIFY_OAUTH_DOMAIN!,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: process.env.REACT_APP_AMPLIFY_OAUTH_REDIRECT_SIGNIN!,
      redirectSignOut: process.env.REACT_APP_AMPLIFY_OAUTH_REDIRECT_SIGNOUT!,
      responseType: 'code',
    },
  },
};

if (process.env.REACT_APP_ENV !== 'local') {
  AmplifyConfig.Auth.cookieStorage = {
    domain: process.env.REACT_APP_AMPLIFY_OAUTH_COOKIESTORAGE_DOMAIN!,
    path: '/',
    expires: 365,
    secure: process.env.NODE_ENV === 'production' ? true : false,
  };
}

export default AmplifyConfig;
